import { Pipe, PipeTransform } from '@angular/core';
import { isArray, isObject, orderBy } from 'lodash';

@Pipe({ name: 'orderBy' })
export class OrderByPipe implements PipeTransform {
	transform(
		value: Array<{ [key: string]: any }>,
		properties: Array<string>,
		orders: Array<'asc' | 'desc'>
	): Array<{ [key: string]: any }> {
		if (!isArray(value)) {
			return value;
		}

		if (value.map((value) => isObject(value)).includes(false)) {
			return value;
		}

		return orderBy(value, properties, orders);
	}
}
